$(document).ready(function () {

    // <iframe></iframe>
    var iframeList = {
        "contractAgreeHtml" : installmentAgreeList,// 割賦契約の同意事項
        "corporalInfoHtml" : personalInformationAttentionList,// 個人情報の取扱・購入時の注意事項
        "machineInfoHtml" : machineInformationAttentionList, // 移動機物品販売の注意事項
        "campaignHtml" : campaignAttentionList, // 下取りに関する同意事項
        "newTokusuruSupportHtml" : newTokusuruSupportAttentionList, // 新トクするサポート注意事項
        "newTokusuruSupportInfoHtml" : newTokusuruSupportInfoAttentionList, // 新トクするサポート特典利用に関する注意事項
        "tokusuruSupportHtml" : tokusuruSupportAttentionList, // トクするサポート注意事項
        "tokusuruSupportPlusHtml" : tokusuruSupportPlusAttentionList, // トクするサポート+注意事項
    };

    for (var key in iframeList) {
        if ($("#" + key)) {
            var srcUrl = getEnviromentInfo(iframeList[key]);
            if ($("#" + key).prop("src") != srcUrl) {
                $("#" + key).prop("src", srcUrl);
            }
        }
    }

    // <div></div>
    var divList = {
        "goodInfoHtml" : returnList// 商品の返品・交換に関する注意事項
    };

    for (var key in divList) {
        if ($("#" + key)) {
            var srcUrl = getEnviromentInfo(divList[key]);
            $("#" + key).load(srcUrl);
        }
    }

    // <a></a>
    var aLinkList = {
        "customerInputResearchAddress1" : postalCodeList, // 郵便番号を調べる
        "customerInputResearchAddress2" : postalCodeList, // 郵便番号を調べる
        "deliveryInputResearchAddress1" : postalCodeList, // 郵便番号を調べる
        "deliveryInputResearchAddress2" : postalCodeList, // 郵便番号を調べる
        "mailAddressDetail1" : mailaddressList, // お知らせの詳細を確認する
        "mailAddressDetail2" : mailaddressList, // お知らせの詳細を確認する
        "selfConfirm" : kakuninList,  // その他の確認書類を確認する
        "selfConfirmDetailItemHtml" : selfConfirmDetailList  // 本人確認について更に詳しく見る
    }

    for (var key in aLinkList) {
        if ($("#" + key)) {
            var srcUrl = getEnviromentInfo(aLinkList[key]);
            if ($("#" + key).prop("href") != srcUrl) {
                $("#" + key).prop("href", srcUrl);
            }
        }
    }

    // 予約遷移
    if (typeof OLS_APPLY_URL != "undefined") {
        OLS_APPLY_URL = getEnviromentInfo(olsApplyList);
    }

    // ご利用可能なカード会社の画像パスを設定する
    var srcUrl = getEnviromentInfo(cardCompanyImgList);
    $("#VISA").attr("src", srcUrl + "logo_visa.jpg");
    $("#MasterCard").attr("src", srcUrl + "logo_master.jpg");
    $("#JCB").attr("src", srcUrl + "logo_jcb.jpg");
    $("#AMERICAN_EXPRESS").attr("src", srcUrl + "logo_amex.jpg");
    $("#Diners_Club").attr("src", srcUrl + "logo_diners.jpg");

});
